import { Colors } from 'baseStyles/enums/colors'
import React from 'react'
import FlexBox from 'schoolUiComponents/basic/Box/FlexBox'
import TeacherSignupHeader from './components/Header'
import TeacherSignupForm from './components/SignupForm'
import Testimonials from './components/Testimonials'
import TeacherSignupStyles from './style'
import { useTeacherSignupState } from './state'
import TermsAndConditionsPopup from './components/TermsAndConditionsPopup'
import './styles.scss'

const TeacherSignupView = () => {

    const themeStyles = TeacherSignupStyles();
    const { isTncPopupVisible } = useTeacherSignupState();

    return (
        <>
            <div className='teacher-signup-view-container'>
                <div className="ajax_spinner" id="ajax-spinner-id"></div>
                {/* <TeacherSignupHeader /> */}
                <FlexBox alignStart borderRadius={12} background={Colors.WHITE} {...themeStyles.mainBox}>
                    <Testimonials />
                    <TeacherSignupForm />
                </FlexBox>
            </div>
            {isTncPopupVisible ?  <TermsAndConditionsPopup /> : null}
        </>
    )
}

export default TeacherSignupView